(() => {
  const parseSiblings = (cta) => {
    const node = cta.parentElement?.querySelector("[data-inventory-siblings]");
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch {
      return {};
    }
  };

  const syncDisabled = (cta, wrapper) => {
    const disabled =
      wrapper.classList.contains("variant--soldout") ||
      wrapper.classList.contains("variant--unavailable");

    cta.toggleAttribute("aria-disabled", disabled);
    cta.tabIndex = disabled ? -1 : 0;
  };

  const syncForVariant = (cta, variantId) => {
    if (!cta._siblingUrls) cta._siblingUrls = parseSiblings(cta);
    const url =
      cta._siblingUrls[variantId] || cta._siblingUrls[String(variantId)] || "";
    const visible = Boolean(url);
    const ctas = cta.closest(".product__submit__ctas");
    const item = cta.closest(".product__submit__item");

    cta.hidden = !visible;
    if (url) cta.setAttribute("href", url);

    ctas?.classList.toggle("product__submit__ctas--split", visible);

    if (item?.querySelector(".product-form__quantity")) {
      item.classList.toggle("product__submit__item--inline", !visible);
    }
  };

  const init = () => {
    document.querySelectorAll("[data-customize-sibling]").forEach((cta) => {
      const wrapper = cta.closest("[data-form-wrapper]");
      if (!wrapper) return;

      cta._siblingUrls = parseSiblings(cta);
      syncDisabled(cta, wrapper);

      new MutationObserver(() => syncDisabled(cta, wrapper)).observe(wrapper, {
        attributes: true,
        attributeFilter: ["class"],
      });

      cta.addEventListener("click", (event) => {
        if (cta.hidden || cta.getAttribute("aria-disabled") === "true") {
          event.preventDefault();
        }
      });
    });
  };

  document.addEventListener("theme:variant:change", (event) => {
    const variantId = event.detail?.variant?.id;
    const root = event.target.closest("[data-product]") || document;

    root.querySelectorAll("[data-customize-sibling]").forEach((cta) => {
      syncForVariant(cta, variantId);
      const wrapper = cta.closest("[data-form-wrapper]");
      if (wrapper) syncDisabled(cta, wrapper);
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
